

























































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { isNull } from 'lodash';

import PaginationInterface from '@core/interfaces/pagination-interface';
import { BPCDisplayConfig } from '@core/interfaces/bpc-display-config';
import { messageDisplayFields, messageFilters } from '@/config/messages';

import ContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';
import TableWrapper from '@shared/layouts/wrappers/table/table-wrapper.vue';
import GridMock from '@shared/components/mocks/grid-mock/grid-mock.vue';

import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import MultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import SearchInput from '@shared/components/forms/inputs/search-input.vue';

import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import moment from 'moment';
import Table from '@shared/components/tables/table.vue';
import MessageSingle from '@communications/components/singles/message-single.vue';
import BulkMoveToTrashModal from '@shared/components/modals/bulk-move-to-trash-modal/bulk-move-to-trash-modal.vue';
import DisplayFieldBadge from '@shared/components/displays/display-field-badge/display-field-badge.vue';
import { Message } from '@communications/interfaces/message';
import DisplayFieldArray from '@shared/components/displays/display-field-array/display-field-array.vue';
import Datepicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';

@Component({
  name: 'bpc-message-list',
  components: {
    'bpc-content-wrapper': ContentWrapper,
    'bpc-table-wrapper': TableWrapper,
    'bpc-grid-mock': GridMock,
    'bpc-entity-select': EntitySelect,
    'bpc-multi-select': MultiSelect,
    'bpc-search-input': SearchInput,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-table': Table,
    'bpc-message-single': MessageSingle,
    'bpc-bulk-move-to-trash-modal': BulkMoveToTrashModal,
    'bpc-display-field-badge': DisplayFieldBadge,
    'bpc-display-field-array': DisplayFieldArray,
    'bpc-datepicker': Datepicker,
  },
})
export default class MessageList extends Vue {
  // PROPS
  @Prop({ type: Object }) readonly initialFilters: {
    search: string;
    sender_receiver_id: number;
    status: string;
    date: string;
  };
  @Prop({ type: Object }) readonly initialCustomFilters: {};
  @Prop({ type: String }) readonly actionsPortalTarget: string;
  @Prop({ type: Boolean }) readonly withUrlParams: boolean;

  // DATA
  moment: any; // NOTE make moment pipe work with typescript
  loading: boolean = false;
  loadingAccounting: boolean = false;
  urlParams: Record<string, string> = {};
  config: BPCDisplayConfig = null;
  messageItems: Message[] = [];

  submittedSearch = '';
  selectedContact = null;
  selectedStatus = null;
  selectedDate = null;

  pageOptions: number[] = [5, 10, 15, 20, 50, 100, 200];
  pagination: PaginationInterface = {
    current_page: 1,
    last_page: 1,
    per_page: 15,
    from: 0,
    to: 0,
    total: 0,
  };

  gridCols: object = {
    sm: 12,
    md: 6,
    lg: 4,
  };

  showDrawerSection = false;
  formModel: Partial<Message> = null;
  timestamp = moment().unix();
  selection = [];
  filterModel = null;
  entityName = 'message';
  dataToShowInBulkReports = [];
  checkedAllEntities = false;
  searchAndOrderQueryParams = {};
  customFilters = {};

  messageFieldsToShow = [
    {
      key: 'sender_name',
      headerLabel: 'messages.sender_name.label',
    },
    {
      key: 'title',
      headerLabel: `messages.title.label`,
    },
    {
      key: 'receivers',
      headerLabel: 'messages.receivers.label',
    },
    {
      key: 'created_at',
      headerLabel: 'messages.created_at.label',
    },
    {
      key: 'status',
      headerLabel: `global.status.label`,
    },
    {
      key: 'channels',
      headerLabel: 'messages.channels.label',
    },
  ];
  // LIFECYCLE

  // created() {}
  mounted() {
    this.initializeFiltersFromProperties();
    this.initializeValuesFromUrlParams();
    this.getMessagesIfStopChanging();
  }
  // updated(){}
  // destroyed(){}

  // COMPUTED
  get formClosePortalTarget(): string {
    return `message-form-close-portal-target-${this.timestamp}`;
  }

  get filtersConfig() {
    return messageFilters;
  }
  get displayConfig() {
    return messageDisplayFields;
  }

  get changeDetectorStr(): string {
    return [
      this.pagination.per_page,
      this.pagination.current_page,
      this.submittedSearch,
      this.selectedContact,
      this.selectedStatus,
      this.selectedDate,
    ].join('--');
  }

  get noLabel() {
    // TODO initialize correctly the "for" attribute in field-wrapper
    return {
      labelAttributes: {
        for: 'test',
      },
    };
  }

  // METHODS
  clickOnShow(data) {
    this.formModel = data.item;
    this.showDrawerSection = true;
  }

  onCheckAll(val: boolean) {
    this.checkedAllEntities = val;
  }

  get checkedItems(): Message[] {
    return this.messageItems.filter(item => item['checked']);
  }

  initializeFiltersFromProperties() {
    if (this.initialFilters) {
      this.submittedSearch = this.initialFilters?.search || '';
      this.selectedStatus = this.initialFilters?.status || '';
      this.selectedDate = this.initialFilters?.date || '';
      if (this.initialFilters?.sender_receiver_id) {
        this.selectedContact = this.initialFilters?.sender_receiver_id;
      } else {
        this.selectedContact = null;
      }
    }
    if (this.initialCustomFilters) {
      this.customFilters = { ...this.initialCustomFilters };
    }
  }

  initializeValuesFromUrlParams() {
    if (this.withUrlParams) {
      const urlParams = this.getUlrParams();
      if (this.submittedSearch) {
        this.submittedSearch = urlParams?.search || '';
      }

      if (!this.selectedStatus) {
        this.selectedStatus = urlParams?.status || '';
      }

      if (!this.selectedDate) {
        this.selectedDate = urlParams?.date || '';
      }

      if (!this.selectedContact) {
        if (urlParams?.sender_receiver_id) {
          this.selectedContact = urlParams?.sender_receiver_id;
        } else {
          this.selectedContact = null;
        }
      }

      if (this.initialCustomFilters) {
        Object.keys(this.initialCustomFilters).forEach(key => {
          if (!this.customFilters[key]) {
            this.customFilters[key] = urlParams[key] || null;
          }
        });
      }
    }
  }

  getMessagesIfStopChanging() {
    const changeStr = this.changeDetectorStr;
    setTimeout(() => {
      if (changeStr === this.changeDetectorStr) {
        this.getMessages();
      }
    }, 300);
  }

  async getMessages() {
    this.loading = true;
    this.checkedAllEntities = false;
    this.loadingAccounting = true;
    const params = this.getQueryParams();
    const url = this.$bpcApiRouteHelper.getEntityPath('message');
    const res = await this.$bpcApi.get(url, { params: params }).toPromise();
    this.messageItems = res.data;
    this.pagination = res.meta;
    this.setUrlParams(params);
    this.loading = false;
  }

  getQueryParams() {
    return {
      order_by: 'created_at',
      order_direction: 'desc',
      per_page: this.pagination.per_page,
      page: this.pagination.current_page,
      search: this.submittedSearch,
      sender_receiver_id: this.selectedContact,
      status: this.selectedStatus,
      date: this.selectedDate,
      ...this.customFilters,
    };
  }

  getUlrParams() {
    const urlQueryParams = JSON.parse(JSON.stringify(this.$route.query), (k, v) => {
      if (!isNaN(v) && !isNull(v)) {
        return parseInt(v);
      }
      return v;
    });
    return {
      ...urlQueryParams,
    };
  }

  setUrlParams(params) {
    if (this.withUrlParams) {
      this.$router.push({ query: params }).catch(e => {
        return null;
      });
    }
  }

  clickOnReload() {
    this.getMessagesIfStopChanging();
  }

  onCloseModal() {
    this.formModel = null;
    this.showDrawerSection = false;
  }

  // WATCHERS

  @Watch('changeDetectorStr')
  onChangeDetectorStrChange(val) {
    if (val) {
      this.getMessagesIfStopChanging();
    }
  }
}
